import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.99953 14.75C9.74367 14.75 9.48768 14.6432 9.29269 14.4296L3.29296 7.86707C2.90235 7.43982 2.90235 6.74768 3.29296 6.32043C3.68356 5.89319 4.31635 5.89319 4.70696 6.32043L9.99953 12.1113L15.293 6.32129C15.6837 5.89404 16.3164 5.89404 16.707 6.32129C17.0977 6.74853 17.0977 7.44067 16.707 7.86792L10.7073 14.4304C10.512 14.644 10.2558 14.75 9.99953 14.75Z",
		fill: "#0D2976"
	})
});
export default SvgChevronDown;
